<template>
  <div>
    <PaymentDetails></PaymentDetails>
  </div>
</template>

<style scoped>

</style>

<script>
import Payment from "./Payment.ts";
export default Payment;
</script>